import cloneDeep from 'lodash.clonedeep';

import { algoliaApiSearch } from 'algolia-api/algoliaApiSearch';
import getSearchQueryOptions from 'algolia-api/search/getSearchQueryOptions';
import { ApiSearchResults } from 'api/search';
import {
  MainSearchResults,
  MainStoreMainSearchState,
} from 'modules/main/store/ducks/MainStoreMainSearchState';
import { MainStoreSearchRadiusState } from 'modules/main/store/ducks/searchRadius';
import { configString } from 'utils/config';
import { MAIN_SEARCH_FACETS } from 'utils/mainSearchFacets';

type Args = {
  state: {
    mainSearch: MainStoreMainSearchState;
    searchRadius: MainStoreSearchRadiusState;
  };
  pageIndex?: number;
};

export async function executeSearchQuery({
  state: {
    mainSearch,
    searchRadius: { value: searchRadius },
  },
  pageIndex,
}: Args): Promise<MainSearchResults> {
  const timestamp = new Date().getTime();

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const sort = mainSearch.sort[mainSearch.filters.type];

  // Include additional filter options to go with certain options.
  const filters = cloneDeep(mainSearch.filters);

  Object.keys(filters).forEach((filterKey) => {
    const facet = MAIN_SEARCH_FACETS[filterKey];
    const filter = filters[filterKey];

    if (facet?.includeAdditionalOption) {
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error fix types
      const updatedFilter = [...filter];
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error fix types
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      filter.forEach((filterOption: any) => {
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        if (filterOption in facet.includeAdditionalOption) {
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          updatedFilter.push(facet.includeAdditionalOption[filterOption]);
        }
      });
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error fix types
      filters[filterKey] = updatedFilter;
    }
  });

  const queryOptions = getSearchQueryOptions(MAIN_SEARCH_FACETS, {
    location: mainSearch.searchLocation,
    radius: searchRadius,
    ...mainSearch,
    filters,
    sort,
    pageIndex: pageIndex !== undefined ? pageIndex : mainSearch.pageIndex,
  });

  const searchConfig = {
    appId: configString('algolia', 'appId'),
    apiKey: configString('algolia', 'searchApiKey'),
  };

  const algoliaResponse = await algoliaApiSearch<ApiSearchResults>({
    config: searchConfig,
    query: mainSearch.query,
    queryOptions,
  });

  return {
    ...(algoliaResponse as unknown as ApiSearchResults),

    // Add the searchLocation so that we know which location the results are for
    searchLocation: mainSearch.searchLocation,
    searchId: mainSearch.searchId,

    // Add a timestamp to keep track of when the query was executed
    timestamp,

    // This is for analytics
    searchParameters: {
      query: mainSearch.query,
      queryOptions,
    },
  };
}
